module.exports = __webpack_public_path__ + "img/pic_muyulu2.58cc2170.png";